import { body } from "../elements";

export function useAccordion() {
  function Accordion(acc) {
    if (!(acc instanceof Element)) {
      return;
    }

    const items = acc.querySelectorAll(".accordion__item");
    const btns = acc.querySelectorAll(".accordion__button");
    const contents = acc.querySelectorAll(".accordion__content");

    function setHeights() {
      contents.forEach((content) => {
        const height = content.offsetHeight;
        content
          .closest(".accordion__content--wrap")
          .setAttribute("style", `--height: ${height}px;`);
      });
    }

    function closeAll() {
      items.forEach((item) => {
        item.classList.remove("active");
        item.setAttribute("aria-expanded", "false");
      });
    }

    function open(item) {
      const ref = item.getAttribute("href");
      const target = acc.querySelector(ref);
      closeAll();
      setHeights();
      target.classList.add("active");
      target.setAttribute("aria-expanded", "true");
      window.history.pushState("", "", ref);
    }

    btns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const parent = btn.closest(".accordion__item");
        if (parent.classList.contains("active")) {
          closeAll();
        } else {
          open(btn);
        }
      });
    });

    setHeights();

    const accordionResizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeights();
      }
    });
    accordionResizeObserver.observe(body);

    function refActivate() {
      if (window.location.hash) {
        const activeOnLoad = acc.querySelector(window.location.hash);
        activeOnLoad && activeOnLoad.classList.add("active");
      }
    }

    refActivate();
  }

  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((acc) => {
    Accordion(acc);
  });
}
